module.exports = __webpack_public_path__ + "img/list_dash.736011ad.svg";